var wSize = $(window).outerWidth();
var hSize = $(window).innerHeight();
var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').outerHeight();


$(document).ready(function() {
    
    if ($('.drop.dropdown-menu').length) {
        function adjustDropdownWidths() {
            $('.drop.dropdown-menu').each(function () {
                var $drop = $(this);
                var dropKey = $drop.data('drop');
                var $navItem = $('.nav-item[data-drop="' + dropKey + '"]');

                if (!$navItem.length) return; // Skip if no matching nav item

                // Temporarily show dropdown if hidden (so we can measure items correctly)
                var wasHidden = $drop.css('display') === 'none';
                if (wasHidden) $drop.css({ visibility: 'hidden', display: 'block' });

                var navItemWidth = $navItem.outerWidth();
                var maxItemWidth = 0;

                // Find the widest <a.item span> inside this dropdown
                $drop.find('a.item span').each(function () {
                    var itemWidth = $(this).outerWidth();
                    if (itemWidth > maxItemWidth) {
                        maxItemWidth = itemWidth;
                    }
                });

                if (maxItemWidth > 0) {
                    // Add 40px to widest item
                    var finalWidth = maxItemWidth + 40;

                    // Ensure dropdown is not narrower than nav item
                    if (navItemWidth > finalWidth) {
                        finalWidth = navItemWidth;
                    }

                    $drop.css('width', finalWidth);
                } else {
                    // No a.item span, follow nav-item width
                    $drop.css('width', navItemWidth);
                }

                // Re-hide dropdown if it was hidden
                if (wasHidden) $drop.css({ visibility: '', display: 'none' });
            });
        }

        adjustDropdownWidths()
        // Run once after window load (ensures fonts + layout are ready)
        $(window).on('load', adjustDropdownWidths);

        // Also recalc on window resize
        $(window).on('resize', adjustDropdownWidths);
    }

  const Shopifyvideos = document.querySelectorAll('video[autoplay]');

  for (const video of Shopifyvideos) {
    if (video.hasAttribute('muted') || video.muted === true) {
      video.muted = true; // Ensure muted is applied

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.warn('Autoplay failed:', error);
        });
      }

      break; // Play only one video, then stop the loop
    }
  }
  
    $('.announcement-close').on('click', function() {
      $('.announcement-bar').hide();
      if ($('.banner-slider').length) {
          $('.banner-slider').css('height', '100vh');
      }
      setTimeout(function() {
          hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').outerHeight();
        
          $('body').css('padding-top', `${ hAnnouncementbarDynamic }px`);
      
          $('.sticky-top').css('top', `${ hAnnouncementbarDynamic  + 30}px`);
          $('.nav-mobile').css('height', `${hSize -  hAnnouncementbarDynamic }px`);
          $('.predictive-search .wrapper').css('margin-top', `0`);
          
          if ($('.header-nav-section').length) {
              $('.header-nav-section').css('top', `${ hAnnouncementbarDynamic}px`);
          }
          if ($('.main-support-nav').length) {
              $('.main-support-nav').css('top', `${ hAnnouncementbarDynamic}px`);
          }
          if ($('.main-product-support-nav').length) {
              $('.main-product-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
          }
      }, 100);
      
    });
  
    /* PRELOADER ----------------------------- */
    if ($('.preloader').length) {
        runScenes();
    }
  
    /* Header Height ----------------------------- */
    
    let headerH = $('.header').height();
    $('body').css('padding-top', `${headerH}px`);

    $('.sticky-top').css('top', `${headerH + 30}px`);
    $('.nav-mobile').css('height', `${hSize - headerH}px`);
  
    /* Mega Menu -------------------------------- */

    if ($('.mega-navs').length) {
        $('.mega-navs .mega-nav:first-child').addClass('active');
    }
    if ($('.mega-tabs').length) {
        $('.mega-tabs .mega-tab:first-child').addClass('active');
    }
  
    /* DATA AOS ---------------------------------- */

    $('[data-aos]').addClass('aos-init');

  
    $('.video--tag').each(function() {
        var $container = $(this);
        var $video = $container.find('video')[0];
        var $progressCircle = $container.find('.progress-circle');
        var radius = 45; // Radius of the circle
        var circumference = 2 * Math.PI * radius; // Circumference of the circle
    
        // Initialize the circle progress
        $progressCircle.css('strokeDasharray', circumference);
        $progressCircle.css('strokeDashoffset', circumference);
    
        // Update the circle's progress as the video plays
        $video.addEventListener('timeupdate', function() {
            var progress = $video.currentTime / $video.duration;
            var offset = circumference - (progress * circumference);
            $progressCircle.css('strokeDashoffset', offset);
        });
    
        // Event listener for play event
        $video.addEventListener('play', function() {
            $container.find('.play-pause-button').addClass('playing');
        });
    
        // Event listener for pause event
        $video.addEventListener('pause', function() {
            $container.find('.play-pause-button').removeClass('playing');
        });
    
        // If the play-pause button is clicked
        $container.find('.play-pause-button').on('click', function() {
            if ($video.paused) {
                $video.play();
            } else {
                $video.pause();
            }
        });
    });

    
    if ($('.header-nav-section').length) {
        
        $('.header-nav-section').css('top', `${ hAnnouncementbarDynamic - 3 }px`);
        $(window).resize(function() {
            $('.header-nav-section').css('top', `${ hAnnouncementbarDynamic - 3 }px`);
        });
        
        $('.header-nav-section').each(function () {
            var $container = $(this); 
            $container.find('.nav-item').click(function(){
              
              
                $('.nav-item').removeClass('active');
                $(this).addClass('active');
        
              
                var targetAttr = $(this).attr('data-scroll');
                var $targetSection = $('.section-scroll[data-scroll="' + targetAttr + '"]').offset().top - 150;
                $("html, body").animate({
                    scrollTop: $targetSection
                }, 1);
            });
        });
    
        $(window).on('scroll', function() {
            $(".section-scroll").each(function() {
                var sectionTop = $(this).offset().top - 170;
                var sectionBottom = sectionTop + $(this).outerHeight();
                var scrollPosition = $(window).scrollTop();
                
                var targetButton = $('.header-nav-section .nav-item[data-scroll="' + $(this).attr('data-scroll') + '"]');
            
                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    targetButton.addClass("active");
                    
                    // Check if the section has a data-child-scroll attribute
                    var childScroll = $(this).attr("data-child-scroll");
                    if (childScroll) {
                        $('.header-nav-section .nav-item[data-scroll="' + childScroll + '"]').addClass("active");
                    }
                } else {
                    if (!$(this).attr("data-child-scroll")) {
                        targetButton.removeClass("active");
                    }
                }
            });
        });
    }
    
    section_scroll_animation();
    aos_animate();
    animate_section();
    backToTop();

    function closePopup() {
        $('.popup__overlay').removeClass('active');
    
        // Check if iframe exists
        var $iframe = $('#modal #embed_video iframe');
        if ($iframe.length) {
            // Clear the embed container
            $("#modal #embed_video").html("");
    
            // Stop iframe video playback (reset src)
            $iframe.attr('src', $iframe.attr('src'));
        } else {
            // Check for a <video> element and stop it
            var $video = $('.modal_box #embed_video video');
            if ($video.length) {
                $video.get(0).pause();     // Pause the video
                $video.get(0).currentTime = 0; // Reset to start
            }
        }
    }
    
    $('.overlay-close, .popup__close').click(closePopup);

  
    $(document).on('click', '.btn-notify-me', function() {
        var modalId = $(this).data('modal-id');
        $('.renovation-collection-modal, .collection-modal').filter(function() {
            return $(this).data('modal-id') == modalId;
        }).addClass('active');
    });

  
    condfidence_scroll();

    

    $('.event-product-item').each(function() {
        let $item = $(this);
        $item.find('.selector-variant').on('change', function() {
            let $selected = $(this).find('option:selected');
            let selectedValue = $selected.val();
            let salePrice = $selected.attr('sale-price');
            let comparePrice = $selected.attr('compare-price');
            let variantImage = $selected.attr('variant-image');
            let variantTitle = $selected.attr('variant-title');
            let sale = $selected.attr('variant-sale');
    
            var newHref = "/cart/" + selectedValue + ":1";
            
            let $form = $item.find('form');
            $form.find('input[name="id"]').val(selectedValue);
    
            $item.find('.text-sale-price').html(salePrice);
            $item.find('.text-compare-price').html(comparePrice);
            $item.find('.free-gift-container .free-gift-featured-image img').attr('src', variantImage);
            $item.find('.free-gift-container .variant-title').text(variantTitle);
            if(sale == 0){
              $item.find('.save-tag').addClass('hidden');
              $item.find('.media-image-save-tag ').addClass('hidden');
            }else{
              $item.find('.save-tag').removeClass('hidden');
              $item.find('.save-tag .sale-amount').html(sale);
              $item.find('.media-image-save-tag ').removeClass('hidden');
              $item.find('.media-image-save-tag .save-tag-data').html(sale);
            }
            $item.find('.btn-add-to-cart').attr("href", newHref);
        });
    });
  
});

$(document).on('click', '.btn--buy-now', function (e) {
    e.preventDefault();
  
    var variantId = $(this).data('variant-id');
    var qty = $(this).data('qty') || 1;
  
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({
        id: variantId,
        quantity: parseInt(qty)
      }),
      dataType: 'json',
      contentType: 'application/json',
      success: function (data) {
        window.location.href = '/checkout';
      },
      error: function (xhr, status, error) {
        console.error('Error:', error);
        console.log('There was a problem adding the product to your cart.');
      }
    });
});

$(document).on('change', '.related-product-card-item .selector-variant', function () {
    let $selector = $(this);
    let $item = $selector.closest('.related-product-card-item');

    let $selected = $selector.find('option:selected');
    let selectedValue = $selected.val();
    let salePrice = $selected.attr('sale-price');
    let comparePrice = $selected.attr('compare-price');
    let variantImage = $selected.attr('variant-image');
    let variantTitle = $selected.attr('variant-title');
    let sale = $selected.attr('variant-sale');

    $item.find('.variant-selected-info .vairant-title').text(variantTitle);
    $item.find('.variant-selected-info .variant-image img').attr('src', variantImage);
    
    $item.find('.text-sale-price span').html(salePrice);
    $item.find('.text-compare-price span').html(comparePrice);
    $item.find('.atc-form .main-id').val(selectedValue);
  
    if(sale == 0){
      $item.find('.save-tag, .discount-tag').addClass('hidden');
      
    }else{
      $item.find('.save-tag, .discount-tag').removeClass('hidden');
      $item.find('.save-tag .sale-amount, .discount-tag span').html(sale);
    }
  
});



$(window).on('resize', function() {
    wSize = $(window).outerWidth();
    hSize = $(window).outerHeight();
    

    /* Header Height ----------------------------- */
    setTimeout(function() {
        hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').outerHeight();
        $('body').css('padding-top', `${ hAnnouncementbarDynamic }px`);
    
        $('.sticky-top').css('top', `${ hAnnouncementbarDynamic  + 30}px`);
        $('.nav-mobile').css('height', `${hSize -  hAnnouncementbarDynamic }px`);
      
        if ($('.main-support-nav').length) {
              $('.main-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
        }
        if ($('.main-product-support-nav').length) {
            $('.main-product-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
        }
    }, 100);
  
});

$(window).on('scroll', function() {
    section_scroll_animation();
    aos_animate();
    animate_section();
    backToTop();

  
    condfidence_scroll();
});

function animate_section(){
  if ($('.animate-section').length) {
      $('.animate-section').each(function() {
        let el = $(this);
        if (visiblePercent(el) > 40) {
          $(this).addClass('animate');
        }
        
      });     
  }
}
function backToTop() {
    if ($('.back-to-top').length) {
        let scrollDistance = $(window).scrollTop();
        let vh50 = $(window).height() * 0.5;

        if (scrollDistance >= vh50) {
            $('.back-to-top').fadeIn();
        }
        else {
            $('.back-to-top').fadeOut();
        }
    }
}

$('.back-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
});

function animateSceneText($el, delay = 40, onComplete = null, sceneIndex = 0) {
    const text = $el.text().trim();
    $el.empty().css('visibility', 'visible');

    [...text].forEach((letter, i) => {
        const $span = $('<span>')
            .addClass('split-letter')
            .text(letter)
            .css('transition-delay', `${i * delay}ms`);
        $el.append($span);
    });

    const $letters = $el.find('.split-letter');
    $letters.each(function(i) {
        setTimeout(() => {
            $(this).css({
                opacity: 1,
                transform: 'translateY(0)'
            });
        }, i * delay);
    });

    const totalDuration = $letters.length * delay + 500;

    setTimeout(() => {
        if (sceneIndex === 2) {
            // Scene 3: scale up and then hide preloader
            $('.scene-3').addClass('scale-up');
            setTimeout(() => {
                $('.preloader').addClass('preloader-fade-out');
            }, 400);
            setTimeout(() => {
                $('.preloader').css('display', 'none');
            }, 1100);
        } else {
            // Scene 1 & 2: fade out each letter
            $letters.each(function() {
                $(this).addClass('fade-out');
            });

            // Wait for fade-out transition to complete before next scene
            setTimeout(() => {
                if (typeof onComplete === 'function') onComplete();
            }, 500); // Matches .fade-out transition (0.3s + buffer)
        }
    }, totalDuration);
}


function runScenes() {
    const $scenes = $('.scene-container > div');
    let current = 0;

    function nextScene() {
        if (current >= $scenes.length) return;

        const $scene = $scenes.eq(current);
        $scenes.removeClass('active');
        $scene.addClass('active');

        const $text = $scene.find('.text');
        animateSceneText($text, 40, () => {
            current++;
            nextScene();
        }, current);
    }

    nextScene();
}

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function sectionPercent($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();

    let scrollPercentage = Math.min(100, Math.max(0, ((viewportHeight - elementTop) / elementHeight) * 100));

    return scrollPercentage;
}

function section_scroll_animation() {
    $('.section-animation').each(function() {
            let el = $(this);
      
        if (visiblePercent(el) > 70){
            $(this).addClass('animate');
        }
      
    });
}
function aos_animate() {
    $('.aos-section-animate').each(function () {
        let el = $(this);

        // If any child inside has both data-aos and class 'play-now', animate immediately
        if (el.find('[data-aos].play-now').length > 0) {
            el.find('.aos-init').addClass('aos-animate');
        } 
        // Otherwise, animate if 50% of section is visible
        else if (visiblePercent(el) >= 50) {
            el.find('.aos-init').addClass('aos-animate');
        }
    });
}

$('.mdl .overlay').on('click', function() {
    let parent = $(this).parent();
    parent.fadeOut();

    mld_close(parent);
});
$('.mdl .mdl-close').on('click', function() {
    let parent = $(this).closest('.mdl');
    parent.fadeOut();

    mld_close(parent);
});

function mld_close(parent) {
    if ($('.video-bg-text video').length) {
        $('.video-bg-text video')[0].play();
    }

    if (parent.data('mdl') == 'youtube') {
        $(parent.find('.youtube-wrapper iframe').remove());
    }
    if (parent.data('mdl') == 'size-fit') {
        $(parent.find('.mdl-wrapper').css('left', '100%'));
    }

    $('body').css('overflow-y', 'visible');
}

$('.header .drop1 > div > .item').on('mouseover', function() {

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.header .drop .item i').css('transform', 'scale(1)');
    $this.find('i').css('transform', 'rotate(90deg)');
    
    $('.drop2').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop2[data-drop="' + dropValue + '"]');
        $drop.show();
    }

});

// ANNOUNCEMENT BAR ------------------------------------------>
if ($('.announcement-bar').length) {
    $('.announcement-bar-slider .owl-carousel').each(function() {
        let $carousel = $(this);
        let $floatNav = $('.float-nav-announcement');

      let autoPlayTime = $(this).data('autoplay') * 1000;
      let isAutoplay = $(this).data('autoplay') > 0;
      
        let owl = $carousel.owlCarousel({
            items: 1,
            nav: true,
            dots: false,
            loop: true,
            smartSpeed: 800,
            autoHeight: true,
            autoplay: isAutoplay,
            autoplayTimeout: autoPlayTime,
            margin: 0,
            responsive: {
                0: {
                    margin: 0
                },
                1280: {
                    margin: 0
                }
            }
        }).on('changed.owl.carousel', function(event) {
           setTimeout(function() {
             hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').outerHeight();
              /* Header Height ----------------------------- */
              $('body').css('padding-top', `${ hAnnouncementbarDynamic }px`);
              AnnouncementbarDynamicHeight();
             
              $('.predictive-search .wrapper').css('margin-top', `${ $('.shopify-section-group-header-group .header .announcement-bar').outerHeight() + 2 }px`);
             
               
             
            }, 500);
          
        });
    
        $floatNav.find('.owl-prev').on('click', function() {
            owl.trigger('prev.owl.carousel');
        });
        $floatNav.find('.owl-next').on('click', function() {
            owl.trigger('next.owl.carousel');
        });
    
        $(this).trigger('refresh.owl.carousel');
    });

  
    if ($('.announcement-bar .countdown-bar').length) {
        // Get the target date from the .countdown-bar element
        var targetDate = new Date($('.countdown-bar').data('set-date')).getTime();
        
        // Update the countdown every 1 second
        var countdownInterval = setInterval(function() {
            var now = new Date().getTime();
            var timeDifference = targetDate - now;
        
            var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        
            // Add leading zeros
            days = days < 10 ? '0' + days : days;
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;
        
            // Update DOM
            $('.data-day').text(days);
            $('.data-hours').text(hours);
            $('.data-minutes').text(minutes);
            $('.data-seconds').text(seconds);
        
            // Stop the timer if the date is in the past
            if (timeDifference < 0) {
                clearInterval(countdownInterval);
                $('.data-day, .data-hours, .data-minutes, .data-seconds').text('00');
            }
        }, 1000);

    }
  
    $('.predictive-search .wrapper').css('margin-top', `${ $('.shopify-section-group-header-group .header .announcement-bar').outerHeight() + 2 }px`);
    
}
function AnnouncementbarDynamicHeight(){
  
  hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
  
  if ($('.header-nav-section').length) {
      $('.header-nav-section').css('top', `${ hAnnouncementbarDynamic - 3 }px`);
      $(window).resize(function() {
          $('.header-nav-section').css('top', `${ hAnnouncementbarDynamic - 3 }px`);
      });
  }
  
  if ($('.main-support-nav').length) {
      $('.main-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
  }
 
  if ($('.main-product-support-nav').length) {
      $('.main-product-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
  }
 
  if ($('.after-sale-policy-section').length) {
      var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
      $('.nav-list-vertical').css('top', `${hAnnouncementbarDynamic + 25 }px`);
      $('.tab-selector-policy').css('top', `${hAnnouncementbarDynamic }px`);
      
      $(window).resize(function() {
          var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
          $('.nav-list-vertical').css('top', `${hAnnouncementbarDynamic + 25 }px`);
          $('.tab-selector-policy').css('top', `${hAnnouncementbarDynamic }px`);
      });
  }
  if ($('.confidence-scroll-section').length) {
      var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
      $('.confidence-scroll-section .inner-section').css('top', `${hAnnouncementbarDynamic }px`);
  }
}

$('.header .nav-item').on('mouseover', function() {

    $('.header .nav-items').find('.underline').css('width', '0');
    $(this).find('.underline').css('width', '100%');

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.header .nav-item i').css('transform', 'scale(1)');
    $this.find('i').css('transform', 'scale(-1)');

    $('.header .drop .item i').css('transform', 'scale(1)');
    
    $('.drop').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop[data-drop="' + dropValue + '"]');
        $drop.show();

        let navItemOffset = $this.offset();
        let navItemWidth = $this.outerWidth();
        let dropWidth = $drop.outerWidth();
        
        let leftPosition = navItemOffset.left + (navItemWidth / 2) - (dropWidth / 2);

        $drop.css({
            'left': leftPosition
        });
    }

});

let isMouseOverDrop = false;

$('.header .nav-items').on('mouseleave', function(event) {

    let $navItems = $(this);
    let navItemsOffset = $navItems.offset();
    let navItemsWidth = $navItems.outerWidth();
    let navItemsHeight = $navItems.outerHeight();
    let buffer = 30;

    let extendedLeft = navItemsOffset.left - buffer;
    let extendedRight = navItemsOffset.left + navItemsWidth + buffer;
    let extendedTop = navItemsOffset.top - buffer;
    let extendedBottom = navItemsOffset.top + navItemsHeight + buffer;

    $(document).on('mousemove.navItemsCheck', function(event) {
        let mouseX = event.pageX;
        let mouseY = event.pageY;

        if (mouseX < extendedLeft || mouseX > extendedRight || mouseY < extendedTop || mouseY > extendedBottom) {
            if (!isMouseOverDrop) {
                $('.drop').hide();
                $('.header .nav-item i').css('transform', 'scale(1)');
                $('.header .nav-items').find('.underline').css('width', '0');
            }
        }
    });
});

$('.header .nav-items').on('mouseenter', function() {
    $(document).off('mousemove.navItemsCheck');
});

$('.drop1').on('mouseenter', function() {
    isMouseOverDrop = true;
});

$('.drop1').on('mouseleave', function() {
    isMouseOverDrop = false;
    $('.header .nav-items').trigger('mouseleave');
});

$('.mega-nav').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');
    $('.mega-tab').hide();

    let tab = $(this).data('tab');

    $(`.mega-tab[data-tab="${tab}"]`).css('display', 'flex').hide().fadeIn();
});

$('.icon-search').on('click', function() {
    $('.predictive-search').fadeIn();
});

$('.predictive-search .overlay').on('click', function() {
    $('.predictive-search').fadeOut();
    $('.predictive-search input').val('');
});

$('.predictive-search .icon-close').on('click', function() {
    $('.predictive-search').fadeOut();
    $('.predictive-search input').val('');
});

$(document).on('click', '#predictive-search .view-all', function() {
    $('predictive-search form').trigger('submit');
});

$('.header .nav-toggle').on('click', function() {
    $('inbox-online-store-chat').toggleClass('extra');
    if ($('body').hasClass('menu-open')) {
        $('body').removeClass('menu-open');
        $('body').css('overflow-y', 'visible');
    }
    else {
        $('body').addClass('menu-open');
        $('body').css('overflow-y', 'hidden');
    }
});

$('.nav-mobile a[data-mega]').on('click', function() {
    let mega = $(this).data('mega');
    $(`.mega-mobile[data-mega="${mega}"]`).addClass('show');
});

$('.nav-mobile .mega-title').on('click', function() {
    $('.mega-mobile[data-mega]').removeClass('show');
});

$(document).on('click', '.nav-mobile .accordion-button', function (e) {
    const $target = $(e.target);

    if ($target.is('a')) {
        const href = $target.attr('href');
        
        window.location.href = href;

        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }

    const $button = $(this);
    const target = $button.attr('data-bs-target');
    $(target).collapse('toggle');
});

$('.mega-menu-tab-list .menu-list-tab li').on('mouseenter', function () {
  var tab = $(this).data('tab');
  var $container = $(this).closest('.mega-menu-tab-list');

  $container.find('.menu-list-tab li').removeClass('active');
  $container.find('.mega-menu-tab-list-content').removeClass('active');
  
  $(this).addClass('active');
  $container.find('.mega-menu-tab-list-content[data-tab="' + tab + '"]').addClass('active');
});

// VIDEO PROGRESS ANIMATION
$('.featured-video--tag').each(function() {
    var $container = $(this);
    var $video = $container.find('video')[0];
    var $progressCircle = $container.find('.progress-circle');
    var radius = 45; // Radius of the circle
    var circumference = 2 * Math.PI * radius; // Circumference of the circle

    // Initialize the circle progress
    $progressCircle.css('strokeDasharray', circumference);
    $progressCircle.css('strokeDashoffset', circumference);

    // Update the circle's progress as the video plays
    $video.addEventListener('timeupdate', function() {
        var progress = $video.currentTime / $video.duration;
        var offset = circumference - (progress * circumference);
        $progressCircle.css('strokeDashoffset', offset);
    });

    // Event listener for play event
    $video.addEventListener('play', function() {
        $container.find('.play-pause-button').addClass('playing');
    });

    // Event listener for pause event
    $video.addEventListener('pause', function() {
        $container.find('.play-pause-button').removeClass('playing');
    });

    // If the play-pause button is clicked
    $container.find('.play-pause-button').on('click', function() {
        if ($video.paused) {
            $video.play();
        } else {
            $video.pause();
        }
    });
});


function condfidence_scroll(){
  $('.confidence-scroll-section').each(function() {
    
      var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
      $(this).find('.inner-section').css('top', `${hAnnouncementbarDynamic }px`);
    
      let el = $(this);
      let bgCover = el.find('.confidence-item .bg-cover');
      let targetBox = el.find('.confidence-item-bg-cover');
      let boxItem = el.find('.box-item');
  
      let finalWidth = targetBox.width();
      let finalHeight = targetBox.height();
  
      let startWidth = 1940;
      let startHeight = 940;
      let startTop = -200;
      let finalTop = 0;
  
      let startRadius = 0;
      let finalRadius = 20;
  
      let scrolled = visiblePercent(el); // 0–100
      let progress = (scrolled - 50) / 30; // from 50% to 80%
      progress = Math.max(0, Math.min(1, progress)); // clamp 0–1
  
      let currentWidth = startWidth + (progress * (finalWidth - startWidth));
      let currentHeight = startHeight + (progress * (finalHeight - startHeight));
      let currentTop = startTop + (progress * (finalTop - startTop));
      let currentRadius = startRadius + (progress * (finalRadius - startRadius));
  
      bgCover.css({
        width: currentWidth + 'px',
        height: currentHeight + 'px',
        top: currentTop + 'px',
        'border-radius': currentRadius + 'px'
      });
  
      if (progress === 1) {
        boxItem.addClass('active');
      } else {
        boxItem.removeClass('active');
      }
  });
  
}
$(window).on('scroll resize', condfidence_scroll);
$(window).trigger('scroll');